import { baseColors } from './baseColors';
import { paletteColorsDarkMode } from './paletteColorsDarkMode';
const text = {
    highContrast: {
        on: {
            background: paletteColorsDarkMode.stroke.neutral.text.highContrast.on.background,
            subtle: paletteColorsDarkMode.stroke.neutral.text.highContrast.on.subtle,
            strong: paletteColorsDarkMode.stroke.neutral.text.highContrast.on.strong,
            darkImage: paletteColorsDarkMode.stroke.neutral.text.highContrast.on.subtle,
            lightImage: paletteColorsDarkMode.stroke.neutral.text.highContrast.on.strong,
        },
    },
    primary: {
        on: {
            background: paletteColorsDarkMode.stroke.neutral.text.primary.on.background,
            subtle: paletteColorsDarkMode.stroke.neutral.text.primary.on.subtle,
            strong: paletteColorsDarkMode.stroke.neutral.text.primary.on.strong,
        },
    },
    secondary: {
        on: {
            background: paletteColorsDarkMode.stroke.neutral.text.secondary.on.background,
            subtle: paletteColorsDarkMode.stroke.neutral.text.secondary.on.subtle,
            strong: paletteColorsDarkMode.stroke.neutral.text.secondary.on.strong,
        },
    },
    tertiary: {
        on: {
            background: paletteColorsDarkMode.stroke.neutral.text.tertiary.on.background,
            subtle: paletteColorsDarkMode.stroke.neutral.text.tertiary.on.subtle,
            strong: paletteColorsDarkMode.stroke.neutral.text.tertiary.on.strong,
        },
    },
    critical: {
        on: {
            background: paletteColorsDarkMode.stroke.critical.text.on.background,
        },
    },
    caution: {
        on: {
            background: paletteColorsDarkMode.stroke.caution.text.on.background,
        },
    },
};
const textOverlay = {
    transparent: {
        fill: baseColors.transparent.black['0750'],
        content: {
            on: {
                fill: baseColors.grayscale['0000'],
                content: baseColors.grayscale['0750'],
            },
        },
    },
};
const button = {
    primary: {
        fill: {
            on: {
                background: text.primary.on.background,
            },
        },
        border: {
            on: {
                background: text.primary.on.background,
            },
        },
        content: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: text.secondary.on.background,
                },
            },
            border: {
                on: {
                    background: text.secondary.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsDarkMode.fill.background,
                },
            },
        },
    },
    secondary: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
        border: {
            on: {
                background: text.primary.on.background,
            },
        },
        content: {
            on: {
                background: text.primary.on.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.fill.subtle,
                },
            },
            border: {
                on: {
                    background: text.primary.on.subtle,
                },
            },
            content: {
                on: {
                    background: text.primary.on.subtle,
                },
            },
        },
    },
    tertiary: {
        fill: {
            on: {
                background: text.secondary.on.strong,
            },
        },
        border: {
            on: {
                background: text.secondary.on.strong,
            },
        },
        content: {
            on: {
                background: text.primary.on.subtle,
            },
        },
        hover: {
            fill: {
                on: {
                    background: text.tertiary.on.strong,
                },
            },
            border: {
                on: {
                    background: text.tertiary.on.strong,
                },
            },
            content: {
                on: {
                    background: text.highContrast.on.subtle,
                },
            },
        },
    },
    info: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.info.strong,
            },
        },
        border: {
            on: {
                background: paletteColorsDarkMode.fill.info.strong,
            },
        },
        content: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.stroke.info.text.on.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsDarkMode.stroke.info.text.on.subtle,
                },
            },
            content: {
                on: {
                    background: paletteColorsDarkMode.fill.background,
                },
            },
        },
    },
    celebratory: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.celebratory.strong,
            },
        },
        border: {
            on: {
                background: paletteColorsDarkMode.fill.celebratory.strong,
            },
        },
        content: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.stroke.celebratory.text.highContrast.on.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsDarkMode.stroke.celebratory.text.highContrast.on.subtle,
                },
            },
            content: {
                on: {
                    background: paletteColorsDarkMode.fill.background,
                },
            },
        },
    },
    caution: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.caution.strong,
            },
        },
        border: {
            on: {
                background: paletteColorsDarkMode.fill.caution.strong,
            },
        },
        content: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.stroke.caution.text.on.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsDarkMode.stroke.caution.text.on.subtle,
                },
            },
            content: {
                on: {
                    background: paletteColorsDarkMode.fill.background,
                },
            },
        },
    },
    critical: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.critical.strong,
            },
        },
        border: {
            on: {
                background: paletteColorsDarkMode.fill.critical.strong,
            },
        },
        content: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
        hover: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.stroke.critical.text.on.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsDarkMode.stroke.critical.text.on.subtle,
                },
            },
            content: {
                on: {
                    background: paletteColorsDarkMode.fill.background,
                },
            },
        },
    },
    disabled: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.disabled.subtle,
            },
        },
        border: {
            on: {
                background: paletteColorsDarkMode.fill.disabled.subtle,
            },
        },
        content: {
            on: {
                background: paletteColorsDarkMode.stroke.disabled.text.on.subtle,
            },
        },
    },
};
const link = {
    primary: {
        on: {
            background: text.primary.on.background,
        },
    },
};
const badge = {
    neutral: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
        border: {
            on: {
                background: paletteColorsDarkMode.stroke.neutral.border.decoration.on.background,
            },
        },
        content: {
            on: {
                background: text.primary.on.background,
            },
        },
    },
    highlight: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.info.subtle,
            },
        },
        border: {
            on: {
                background: baseColors.blue.light,
            },
        },
        content: {
            on: {
                background: baseColors.blue.light,
            },
        },
    },
};
const input = {
    empty: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
        border: {
            on: {
                background: paletteColorsDarkMode.stroke.neutral.border.interaction.secondary.on.background,
            },
        },
        content: {
            on: {
                background: text.secondary.on.background,
            },
        },
    },
    filled: {
        fill: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
        border: {
            on: {
                background: paletteColorsDarkMode.stroke.neutral.border.interaction.primary.on.background,
            },
        },
        content: {
            on: {
                background: text.primary.on.background,
            },
        },
    },
    selected: {
        fill: {
            on: {
                background: paletteColorsDarkMode.stroke.neutral.border.interaction.primary.on.background,
            },
        },
        border: {
            on: {
                background: paletteColorsDarkMode.stroke.neutral.border.interaction.primary.on.background,
            },
        },
        content: {
            on: {
                background: paletteColorsDarkMode.fill.background,
            },
        },
    },
    invalid: {
        empty: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.fill.background,
                },
            },
            border: {
                on: {
                    background: text.critical.on.background,
                },
            },
            content: {
                on: {
                    background: text.secondary.on.background,
                },
            },
        },
        filled: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.fill.background,
                },
            },
            border: {
                on: {
                    background: text.critical.on.background,
                },
            },
            content: {
                on: {
                    background: text.primary.on.background,
                },
            },
        },
        selected: {
            fill: {
                on: {
                    background: text.critical.on.background,
                },
            },
            border: {
                on: {
                    background: text.critical.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsDarkMode.fill.background,
                },
            },
        },
    },
    disabled: {
        empty: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.fill.disabled.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsDarkMode.stroke.neutral.border.interaction.secondary.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsDarkMode.stroke.neutral.text.secondary.on.subtle,
                },
            },
        },
        filled: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.fill.disabled.subtle,
                },
            },
            border: {
                on: {
                    background: paletteColorsDarkMode.stroke.neutral.border.interaction.secondary.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsDarkMode.stroke.neutral.text.secondary.on.subtle,
                },
            },
        },
        selected: {
            fill: {
                on: {
                    background: paletteColorsDarkMode.stroke.neutral.border.interaction.secondary.on.background,
                },
            },
            border: {
                on: {
                    background: paletteColorsDarkMode.stroke.neutral.border.interaction.secondary.on.background,
                },
            },
            content: {
                on: {
                    background: paletteColorsDarkMode.fill.background,
                },
            },
        },
    },
};
const effect = {
    focus: {
        outline: {
            on: {
                background: paletteColorsDarkMode.stroke.focused.outline.on.background,
            },
        },
    },
    skeleton: {
        fill: {
            on: {
                background: paletteColorsDarkMode.stroke.neutral.border.decoration.on.background,
            },
        },
        overlay: {
            on: {
                background: paletteColorsDarkMode.stroke.neutral.border.decoration.on.background,
            },
        },
    },
};
export const themeColorsDarkMode = {
    ...paletteColorsDarkMode,
    text,
    button,
    textOverlay,
    link,
    badge,
    input,
    effect,
};
//# sourceMappingURL=themeColorsDarkMode.js.map